import { FC } from 'react';

import classNames from 'classnames';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Paginator: FC<PaginationProps> = ({ currentPage = 0, totalPages, onPageChange }) => {
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
  const pageButtons =
    pages.length > 5
      ? pages.slice(
          Math.max(0, currentPage - (currentPage > totalPages - 3 ? 5 - (totalPages - currentPage) : 3)),
          Math.min(totalPages, currentPage + (currentPage < 3 ? 5 - currentPage : 2))
        )
      : pages;

  return (
    <div className="tw-my-4 tw-flex tw-items-center tw-justify-center tw-space-x-1">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={classNames('tw-rounded-sm tw-text-size-1 tw-text-raa-orange', {
          'tw-cursor-not-allowed tw-opacity-50': currentPage === 1,
          'hover:tw-text-raa-orange-hover': currentPage !== 1
        })}
      >
        <span aria-hidden="true" className={`raa-icon raa-icon-arrow-left tw-text-size-2.25 !tw-no-underline`} />
        <span className="tw-sr-only">Föregående sida</span>
      </button>
      <div className="tw-flex tw-grow tw-justify-center tw-gap-1">
        {currentPage - 3 > 0 && (
          <button
            onClick={() => onPageChange(currentPage - 1)}
            className={`tw-rounded-sm tw-px-3 tw-py-1 tw-text-size-1 tw-text-raa-orange hover:tw-bg-raa-gray-hover hover:tw-text-raa-white`}
          >
            &hellip;
            <span className="tw-sr-only">Föregående sida</span>
          </button>
        )}
        {pageButtons.map((page) => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`tw-rounded-sm tw-px-3 tw-py-1 tw-text-size-1 tw-text-raa-orange ${
              page === currentPage
                ? 'tw-bg-raa-orange tw-text-raa-white'
                : 'hover:tw-bg-raa-gray-hover hover:tw-text-raa-white'
            }`}
          >
            {page}
          </button>
        ))}
        {totalPages > currentPage + 2 && (
          <button
            onClick={() => onPageChange(currentPage + 1)}
            className={`tw-rounded-sm tw-px-3 tw-py-1 tw-text-size-1 tw-text-raa-orange hover:tw-bg-raa-gray-hover hover:tw-text-raa-white`}
          >
            &hellip;
            <span className="tw-sr-only">Nästa sida</span>
          </button>
        )}
      </div>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={classNames('tw-rounded-sm tw-text-size-1 tw-text-raa-orange', {
          'tw-cursor-not-allowed tw-opacity-50': currentPage === totalPages,
          'hover:tw-text-raa-orange-hover': currentPage !== totalPages
        })}
      >
        <span aria-hidden="true" className={`raa-icon raa-icon-arrow-right tw-text-size-2.25 !tw-no-underline`} />
        <span className="tw-sr-only">Nästa sida</span>
      </button>
    </div>
  );
};

export default Paginator;
